// extracted by mini-css-extract-plugin
export default {"case--info--list--title":"y-travel--case--info--list--title--3hbP0"};